module.exports = __webpack_public_path__ + "components/page-header/static/icon-caret-down--black-4d71de941ace39f86c91024f9f3297e0.svg";